import React from "react";
import { FlatList, View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";

type IssuesData = {
  wrong_item_received: number;
  item_damaged: number;
  not_found: number;
  ofd_db_lost_damage: number;
  cx_rto_predelivery: number;
};

type IssueItem = {
  id: number;
  key: number;
  value_txt: string;
  visible: boolean;
};

type IssuesListProps = {
  issuesData: IssuesData;
};

const IssuesList: React.FC<IssuesListProps> = ({ issuesData }) => {
  const data: IssueItem[] = [
    {
      id: 1,
      key: issuesData.wrong_item_received,
      value_txt: `${issuesData.wrong_item_received} गलत आइटम`,
      visible: issuesData.wrong_item_received > 0,
    },
    {
      id: 2,
      key: issuesData.item_damaged,
      value_txt: `${issuesData.item_damaged} डैमेज/ख़राब`,
      visible: issuesData.item_damaged > 0,
    },
    {
      id: 3,
      key: issuesData.not_found,
      value_txt: `${issuesData.not_found} नहीं मिला`,
      visible: issuesData.not_found > 0,
    },
    {
      id: 4,
      key: issuesData.ofd_db_lost_damage,
      value_txt: `${issuesData.ofd_db_lost_damage} लॉस्ट`,
      visible: issuesData.ofd_db_lost_damage > 0,
    },
    {
      id: 5,
      key: issuesData.cx_rto_predelivery,
      value_txt: `${issuesData.cx_rto_predelivery} कस्टमर ने नहीं लिया`,
      visible: issuesData.cx_rto_predelivery > 0,
    },
  ];

  const filteredData = data.filter((item) => item.visible);

  return (
    <FlatList
      horizontal
      showsHorizontalScrollIndicator={false}
      data={filteredData}
      keyExtractor={(item) => item.id.toString()}
      renderItem={({ item }) => (
        <View
          style={[
            styles.issuebtn,
            { marginLeft: 8, marginVertical: 8, elevation: 1 },
          ]}
        >
          <Text
            variant="caption_4"
            style={{ color: color.plain_red, lineHeight: 18 }}
          >
            {item.value_txt}
          </Text>
        </View>
      )}
    />
  );
};

const styles = StyleSheet.create({
  issuebtn: {
    padding: 5,
    paddingHorizontal: 12,
    borderRadius: 18,
    flexDirection: "row",
    elevation: 2,
    backgroundColor: color.white,
    alignItems: "center",
  },
});

export default IssuesList;
